<template>
  <div class="ui-pannel">
    <p class="title">{{$t("user.complete2")}}</p>
    <div class="content">
      <ul class="list">
        <li v-for="(item) in list" :key="item.id">
          <p class="name">{{item.courseName}}<span class="txt">{{item.teacherName}}</span></p>
          <p class="time">
            <span class="txt">{{getDate(item.beginTime)}}</span>
            <span class="txt">{{getTime(item)}}</span>
            <span class="txt">{{item.courseCount}} {{$t("common.lesson")}}</span>
          </p>
          <p class="teacher">
            <span class="txt">{{item.courseName}}</span>
            <!-- <span class="txt">英语</span> -->
            
          </p>
          <div class="btns">
            <a class="ui-btn gray" @click="showCourseInfo(item)">{{$t("course")}}</a>
            <a class="ui-btn" @click="showComment(item)">{{$t("commond")}}</a>
          </div>
        </li>
      </ul>
      <div style="overflow: hidden"><el-pagination class="ui-pagination" @current-change="changePage" background layout="total, prev, pager, next" :total="page.totalCount"></el-pagination></div>
    </div>
    <update :course="courseInfo" v-if="showCourse.show" :info="showCourse" />
    <comment :info="commentInfo" />
  </div>
</template>
<script>
import update from '@/components/UpdateCourse.vue'
import comment from '@/components/PopComment.vue'
import {getStudentStudyCourseList} from '@/service/studentApi.js'
import moment from 'moment'
export default {
  components: {update, comment},
  data(){
    return {
      list: [],
      showCourse: {
        show: false
      },
      courseInfo: {},
      commentInfo: {
        show: false,
        data: []
      },
      page: {
        pageNO: 1,
        pageSize: 10,
        totalCount: 0,
        state: 2
      }
    }
  },
  mounted(){
    this.getStudentStudyCourseList()
  },
  methods: {
    async getStudentStudyCourseList(){
      let res = await getStudentStudyCourseList(this.page)
      if(res.data.status === 1){
        this.list = res.data.data
        this.page.totalCount = res.data.totalCount
        this.$forceUpdate()
      }
    },
    getDate(time){
      return moment(time * 1000).format('DD/MM/YYYY')
    },
    getTime(row){
      return moment(row.beginTime * 1000).format('HH:mm —— ') + moment(row.endTime * 1000).format('HH:mm')
    },
    showCourseInfo(row){
      this.showCourse.show = true
      this.courseInfo = row
    },
    showComment(row){
      this.commentInfo.show = true
      this.commentInfo.data = row
    },
    changePage(val){
      this.page.pageNO = val
      this.getStudentStudyCourseList()
    }
  }
}
</script>
<style lang="scss" scoped>
.list{
  display: flex; padding: 40px; flex-wrap: wrap;
  li{ margin: 10px 10px 20px; width: 405px; border-radius: 5px; box-shadow: 0 3px 21px rgba($color: #7B7B7B, $alpha: .16);padding: 40px 50px;}
  .name{font-size: 28px; line-height: 37px; font-weight: bold;  span{
    font-size: 16px;
    margin-left: 10px;
  }}
  .time{line-height: 19px; color: #999; margin-top: 30px;}
  .teacher{font-size: 16px; margin-top: 10px; line-height: 21px;}
  .txt{margin-right: 10px;}
  .btns{
    margin-top: 22px; border-top: 2px dashed #ddd; padding-top: 30px;
    .gray{margin-right: 20px;}
  }
}
.ui-pagenation{text-align: right;}
</style>
<i18n>
{
  "cn": {
    "course": "课件",
    "commond": "评价"
  },
  "TW": {
    "course": "課件",
    "commond": "評估"
  },
  "en": {
    "course": "Docs ",
    "commond": "Comment"
  }
}
</i18n>